import { Navigate, type RouteObject } from "react-router-dom";
import Layout from "../components/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Pricing from "../pages/pricing/page";
import LitePricing from "../pages/pricing/LitePricingPage";
import LitePage from "../pages/lite/page";
import Partners from "../pages/partners/page";
import AboutPage from "../pages/about/page";
import Integrations from "../pages/integrations/page";
import Terms from "../pages/terms/page";
import Privacy from "../pages/privacy/page";
import IndustryRoute from "../pages/industries/page";
import IndustriesIndex from "../pages/industries/IndustriesIndex";
import FeatureRoute from "../pages/features/page";
import FeaturesIndex from "../pages/features/FeaturesIndex";
import HowItWorksPage from "../pages/how-it-works/page";
import ResourceRoute from "../pages/resources/page";
import ResourcesIndex from "../pages/resources/ResourcesIndex";
import CaseStudyDetailPage from "../pages/resources/CaseStudyDetailPage";
import BlogRoute from "../pages/blog/page";
import ContactPage from "../pages/contact/page";
import RoiCalculatorPage from "../pages/roi-calculator/page";
import CompetitorAlternativePage from "../pages/compare/CompetitorAlternativePage";
import CompareHubPage from "../pages/compare/CompareHubPage";
import { COMPETITOR_ALTERNATIVES } from "../pages/compare/data";
import { REDIRECTS } from "../redirects";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/pricing",
        element: <Pricing />,
      },
      {
        path: "/pricing/lite",
        element: <LitePricing />,
      },
      {
        path: "/lite",
        element: <LitePage />,
      },
      {
        path: "/partners",
        element: <Partners />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/integrations",
        element: <Integrations />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      {
        path: "/privacy",
        element: <Privacy />,
      },
      {
        path: "/industries",
        element: <IndustriesIndex />,
      },
      {
        path: "/industries/:slug",
        element: <IndustryRoute />,
      },
      {
        path: "/features",
        element: <FeaturesIndex />,
      },
      {
        path: "/features/:slug",
        element: <FeatureRoute />,
      },
      {
        path: "/how-it-works",
        element: <HowItWorksPage />,
      },
      {
        path: "/resources",
        element: <ResourcesIndex />,
      },
      {
        path: "/resources/case-studies/:caseSlug",
        element: <CaseStudyDetailPage />,
      },
      {
        path: "/resources/:slug",
        element: <ResourceRoute />,
      },
      {
        path: "/blog/*",
        element: <BlogRoute />,
      },
      {
        path: "/contact",
        element: <ContactPage />,
      },
      {
        path: "/roi-calculator",
        element: <RoiCalculatorPage />,
      },
      {
        path: "/compare",
        element: <CompareHubPage />,
      },
      ...COMPETITOR_ALTERNATIVES.map((d) => ({
        path: `/${d.pathSlug}`,
        element: <CompetitorAlternativePage data={d} />,
      })),
      ...Object.entries(REDIRECTS).map(([from, to]) => ({
        path: from,
        element: <Navigate to={to} replace />,
      })),
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
